import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import {
  updateBalanceHour,
  fetchBankHours,
  updateBankHour,
} from '../../store/actions/balanceHours';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';
// import ExtraHourDialog from '../../components/ExtraHourDialog/ExtraHourDialog';
import { toTimeMask } from '../../shared/masks';

const styles = theme => ({
  header: {
    paddingTop: theme.spacing(3),
  },
  loading: {
    display: 'flex',
  },
  strong: {
    fontWeight: theme.typography.fontWeightStrong,
  },
  inline: {
    margin: theme.spacing(1),
    display: 'inline-block',
  },
});

class BankOfHours extends React.Component {
  componentDidMount() {
    const employeeId = this.props.match.params.id;
    this.props.onUpdateBalanceHour(employeeId);
    this.props.onFetchBankHours(employeeId);
  }

  render() {
    const {
      classes, loading, bankHours, location, balanceLoading, currentBalance,
    } = this.props;
    // const { openModal, currentItem, currentAction } = this.state;

    const columns = [
      { name: 'month', label: 'Mês' },
      { name: 'expected', label: 'Previsto' },
      { name: 'worked', label: 'Realizado' },
      { name: 'paid', label: ' Abonado (Pago em folgas)' },
      { name: 'balanceTotal', label: 'Acumulado' },
    ];

    /*  const actions = [
       {
          name: 'Editar',
          icon: EditIcon,
          onClick: item => this.handleActionClick('Editar', item),
      },
      {
        name: 'Excluir',
        icon: DeleteIcon,
        onClick: item => this.handleActionClick('Excluir', item),
      },
    ]; */

    return (
      <React.Fragment>
        <ContentHeader title="Banco de Horas" subtitle="Consulte os detalhes do banco de horas de seu funcionário">
          {/* <Button
            variant="contained"
            color="primary"
            onClick={() => this.handleActionClick('Adicionar')}
          >
            <AddIcon /> ADICIONAR
        </Button> */}
        </ContentHeader>

        <Paper elevation={2}>
          <Grid container justify="space-around" alignItems="center" className={classes.header}>
            <Grid item>
              <Typography className={classes.inline} variant="body1" color="textSecondary">
                Funcionário:
              </Typography>
              <Typography className={classes.inline} variant="body1">
                {location.state ? location.state.name : null}
              </Typography>
            </Grid>
            <Grid item className={classes.loading}>
              <Typography className={classes.inline} variant="body1" color="textSecondary">
                Banco de Horas:
              </Typography>
              {balanceLoading ? (
                <CircularProgress color="primary" />
              ) : (
                <Typography
                  className={classNames(classes.inline, classes.strong)}
                  variant="body1"
                  color="primary"
                >
                  {currentBalance}
                </Typography>
              )}
            </Grid>

          </Grid>
          <DataTable
            rows={bankHours.map(bankHour => ({
              ...bankHour,
              month: moment(bankHour.month).format('dd/MM/YYYY'),
              worked: toTimeMask(bankHour.worked),
              expected: toTimeMask(bankHour.expected),
              paid: toTimeMask(bankHour.paid),
              balanceTotal: toTimeMask(bankHour.balanceTotal),
            }))}
            columns={columns}
           /* actions={actions} */
            loading={loading}
          />
        </Paper>

        {/* <ExtraHourDialog
          action={currentAction}
          extraHour={currentItem}
          balance={currentBalance}
          open={openModal}
          onChange={this.handleInputChange}
          onClose={this.handleActionCancel}
          onSubmit={this.handleActionConfirm}
       /> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  bankHours: state.balanceHours.bankHours,
  balanceLoading: state.balanceHours.loading,
  currentBalance: toTimeMask(state.balanceHours.currentBalance),
});

const mapDispatchToProps = dispatch => ({
  onUpdateBalanceHour: id => dispatch(updateBalanceHour(id)),
  onFetchBankHours: id => dispatch(fetchBankHours(id)),
  onUpdateBankHour: data => dispatch(updateBankHour(data)),
});

BankOfHours.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  bankHours: PropTypes.array.isRequired,
  balanceLoading: PropTypes.bool.isRequired,
  currentBalance: PropTypes.string.isRequired,
  onUpdateBalanceHour: PropTypes.func.isRequired,
  onFetchBankHours: PropTypes.func.isRequired,
  onUpdateBankHour: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(BankOfHours));
